import { render, staticRenderFns } from "./TotalSalesToday.vue?vue&type=template&id=0313df9c"
import script from "./TotalSalesToday.vue?vue&type=script&lang=js"
export * from "./TotalSalesToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports